import { jsx as n } from "react/jsx-runtime";
import { I as e } from "../icon-DNHpBTHs.mjs";
const r = {
  name: "chevron-down",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M20.136 7.864a.9.9 0 0 0-1.272 0L12 14.727 5.136 7.864a.9.9 0 0 0-1.272 1.272l7.5 7.5a.9.9 0 0 0 1.272 0l7.5-7.5a.9.9 0 0 0 0-1.272Z" clip-rule="evenodd"/></svg>',
  keywords: ["chevron-down"],
  category: "utility"
}, l = (o) => /* @__PURE__ */ n(e, { ...o, svg: r });
l.displayName = "IconChevronDown";
export {
  l as IconChevronDown
};
//# sourceMappingURL=chevron-down.es.js.map
